import { render, staticRenderFns } from "./RelationPercent.vue?vue&type=template&id=52fb1dac"
import script from "./RelationPercent.vue?vue&type=script&lang=ts"
export * from "./RelationPercent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports